import { Box, ImagePlaceHolderIcon } from 'opensolar-ui'
import { makeOpenSolarStyles } from 'themes/makeOpenSolarStyles'
import useImagePrioritization from '../useImagePrioritization'

const useStyles = makeOpenSolarStyles((theme) => ({
  image: {
    height: 60,
    width: 60,
    objectFit: 'contain',
  },
}))

const HardwareImage = ({ imageUrls }: { imageUrls?: (string | null | undefined)[] }) => {
  const classes = useStyles()
  const { currentImageUrl, handleImageError } = useImagePrioritization(imageUrls)

  return (
    <Box display="flex" justifyContent="center">
      {currentImageUrl ? (
        <img src={currentImageUrl} className={classes.image} onError={handleImageError} loading="lazy" />
      ) : (
        <ImagePlaceHolderIcon height="42" width="42" fill="#ADACB0" />
      )}
    </Box>
  )
}

export default HardwareImage
